import * as React from 'react';
import * as _ from 'lodash';
import { Modal, Button, Alert, FormControl, FormGroup, Col, ControlLabel } from 'react-bootstrap';
import { IProductCenter, IContact } from '@nkr/models/index';
import moment from 'moment';
import * as DateTimeModule from 'react-datetime';
import styled from 'styled-components';
import { ProductActionType } from './show';

const DateTime = (DateTimeModule as any).default;

const FormGroupWrapper = styled(FormGroup)`
    display: flex;
    align-items: center;
`;

interface IProps {
    show: boolean,
    center: string,
    product: string,
    productCenter: IProductCenter,
    staffList: IContact[],
    action: ProductActionType,
    onSave: (nextSteps: string, targetDate: string, closeDate: string, closedBy: number) => void,
    onCancel: () => void
}

interface IState {
    nextSteps: string,
    targetDate: string,
    targetDateValid: boolean,
    closeDate: string,
    closedBy: number,
    closedByValid: boolean,
    dirty: boolean
}

class ProductCenter extends React.Component<IProps, IState> {
    readonly state: IState = {
        nextSteps: '',
        targetDate: '',
        targetDateValid: true,
        closeDate: '',
        closedBy: 0,
        closedByValid: true,
        dirty: false
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.action == ProductActionType.Add) {
            this.setState({
                nextSteps: '',
                targetDate: ''
            });
        }

        if (nextProps.action == ProductActionType.Edit) {
            this.setState({
                nextSteps: nextProps.productCenter.nextSteps,
                targetDate: nextProps.productCenter.targetDate
            });
        }

        if (nextProps.action == ProductActionType.Close) {
            this.setState({
                nextSteps: nextProps.productCenter.nextSteps,
                targetDate: nextProps.productCenter.targetDate,
                closeDate: moment().format('MM/DD/YYYY')
            });
        }

        if (nextProps.action == ProductActionType.Reopen) {
            this.setState({
                nextSteps: nextProps.productCenter.nextSteps,
                targetDate: nextProps.productCenter.targetDate,
                closeDate: '',
                closedBy: 0
            });
        }
    }

    handleNextStepsChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            nextSteps: e.currentTarget.value
        });
    }

    handleTargetDateChange = (e: moment.Moment | string) => {
        let targetDate = '';

        if (typeof (e) != 'string') {
            targetDate = e.format('MM/DD/YYYY');
        } else {
            if (moment(e).isValid()) {
                targetDate = e;
            }
        }

        this.setState({
            targetDate
        });
    }

    handleCloseDateChange = (e: moment.Moment) => {
        this.setState({
            closeDate: e.format('MM/DD/YYYY')
        });
    }

    handleClosedByChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            closedBy: parseInt(e.currentTarget.value)
        });
    }

    handleSave = () => {
        let { nextSteps, targetDate, closeDate, closedBy } = this.state;

        let targetDateValid = targetDate != '';
        let closedByValid = this.props.action == ProductActionType.Close ? closedBy > 0 : true;

        this.setState({
            targetDateValid,
            closedByValid,
            dirty: true
        }, () => {
            if (targetDateValid && closedByValid) {
                this.props.onSave(nextSteps, targetDate, closeDate, closedBy);
            }
        });
    }

    getTitle = () => {
        switch (this.props.action) {
            case ProductActionType.Add:
                return 'Add Targeted Product to ' + this.props.center;

            case ProductActionType.Edit:
                return 'Edit Targeted Product for ' + this.props.center;

            case ProductActionType.Close:
                return 'Close Targeted Product for ' + this.props.center;

            case ProductActionType.Reopen:
                return 'Reopen Targeted Product for ' + this.props.center;
        }
    }

    getSaveButtonTitle = () => {
        switch (this.props.action) {
            case ProductActionType.Add:
                return 'Add Targeted Product';

            case ProductActionType.Edit:
                return 'Save Targeted Product';

            case ProductActionType.Close:
                return 'Close Targeted Product';

            case ProductActionType.Reopen:
                return 'Reopen Targeted Product';
        }
    }

    render = () => {
        // Filter out Member Services and NKR Logistics contacts by name
        const staffList = _.sortBy(this.props.staffList.filter(x => 
            !x.fullName.toLowerCase().includes('member services') && 
            !x.fullName.toLowerCase().includes('logistics')
        ), [(item) => {
            return item.lastName;
        }]);

        const title = this.getTitle();
        const saveButtonTitle = this.getSaveButtonTitle();

        return (
            <Modal backdrop='static' show={this.props.show} onHide={this.props.onCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.dirty && (this.state.targetDateValid == false || this.state.closedByValid == false) && (
                        <Alert bsStyle='danger' style={{ padding: '7px 15px' }}>Please complete the fields in red</Alert>
                    )}

                    <FormGroupWrapper>
                        <Col componentClass={ControlLabel} sm={3}>
                            Product:
                        </Col>
                        <Col sm={9}>
                            {this.props.product}
                        </Col>
                    </FormGroupWrapper>

                    <FormGroup>
                        <Col componentClass={ControlLabel} sm={3}>
                            Next Steps:
                        </Col>
                        <Col sm={9}>
                            <FormControl
                                componentClass='textarea'
                                value={this.state.nextSteps}
                                onChange={this.handleNextStepsChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroupWrapper validationState={this.state.dirty && this.state.targetDateValid == false ? 'error' : null}>
                        <Col componentClass={ControlLabel} sm={3}>
                            Target Date:
                        </Col>
                        <Col sm={9}>
                            <DateTime
                                value={this.state.targetDate}
                                input={true}
                                dateFormat={"MM/DD/YY"}
                                timeFormat={false}
                                closeOnSelect={true}
                                inputProps={{ className: "form-control", style: { width: 'initial' } }}
                                onChange={this.handleTargetDateChange}
                            />
                        </Col>
                    </FormGroupWrapper>

                    {this.props.action == ProductActionType.Close && (
                        <FormGroupWrapper>
                            <Col componentClass={ControlLabel} sm={3}>
                                Close Date:
                            </Col>
                            <Col sm={9}>
                                <DateTime
                                    value={this.state.closeDate}
                                    input={true}
                                    dateFormat={"MM/DD/YY"}
                                    timeFormat={false}
                                    closeOnSelect={true}
                                    inputProps={{ className: "form-control", style: { width: 'initial' } }}
                                    onChange={this.handleCloseDateChange}
                                />
                            </Col>
                        </FormGroupWrapper>
                    )}

                    {this.props.action == ProductActionType.Close && (
                        <FormGroupWrapper validationState={this.state.dirty && this.state.closedByValid == false && this.props.action == ProductActionType.Close ? 'error' : null}>
                            <Col componentClass={ControlLabel} sm={3}>
                                Closed By:
                            </Col>
                            <Col sm={9}>
                                <FormControl
                                    componentClass='select'
                                    value={this.state.closedBy}
                                    onChange={this.handleClosedByChange}
                                >
                                    <option value={0}>- select -</option>
                                    {staffList.map((item, index) =>
                                        <option key={'cb-' + index} value={item.id}>{item.lastName}, {item.firstName}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroupWrapper>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.handleSave}>{saveButtonTitle}</Button>
                    <Button onClick={this.props.onCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ProductCenter;